export enum Stage {
  SelectFile = 'select-file',
  MapFields = 'map-fields',
  EmailVerification = 'email-verification',
}

export enum Stages {
  SelectFile = 'select-file',
  MapFields = 'map-fields',
}

export type StageOption = {
  label: string;
  value: Stage;
  disabled?: boolean;
};

export const stageOptions: StageOption[] = [
  {
    label: 'Upload file',
    value: Stage.SelectFile,
  },
  {
    label: 'Map Fields',
    value: Stage.MapFields,
  },
  {
    label: 'Review and Import',
    value: Stage.EmailVerification,
  },
];

export const stageOptionsNew: StageOption[] = [
  {
    label: 'Upload file',
    value: Stage.SelectFile,
  },
  {
    label: 'Map Fields',
    value: Stage.MapFields,
  },
];
